export default __webpack_public_path__ + "static/media/check.fbf3e088.svg";